/* Libs */
import {LeadGeneratedTrackingEvent, LEAD_GEN_SOURCE_TYPES} from '@integrations/segment/leadgen';
import Segment from '../index';

/* Types */
type SegmentTractionActionProps = {zipCode: string; email: string; treatment: string};

/**
 * -------------------------------------------------------------------------------------
 * Define the "event name" here, in TRACKING_TYPES
 */
export const TRACKING_TYPES = {
  geoGetAPrice: 'Geo Get A Price',
};

/**
 * -------------------------------------------------------------------------------------
 * These are just "actions" that are consolidated in one place that
 * will return your properties structure. Just "method" out what you
 * need to handle.
 */
export const SegmentTrackingAction = {
  getAPriceClickSegment({zipCode, email, treatment}: SegmentTractionActionProps) {
    const payload = {
      zipCode,
      email,
      treatment,
    };

    Segment.track(TRACKING_TYPES.geoGetAPrice, payload);
    LeadGeneratedTrackingEvent({email, sourceGroup: LEAD_GEN_SOURCE_TYPES.skuGate});
  },
  emailLowTechCoverageSegment({email}: Pick<SegmentTractionActionProps, 'email'>) {
    LeadGeneratedTrackingEvent({email, sourceGroup: LEAD_GEN_SOURCE_TYPES.skuGateModal});
  },
};
